export let isViewMode = window['VIEW_ONLY'];
export let isViewModeByShareLink = window.location.href.indexOf('/link-share/view') >= 0;
export let isLocal = window.location.href.indexOf('.localhost')>=0;
export let isRemoveSidebar = window.location.href.indexOf('remove_sidebar=1')>=0;
export let isDisableBabyNumber = window.location.href.indexOf('baby_disabled=1')>=0;
export let isDisableW3W = window.location.href.indexOf('w3w_disabled=1')>=0;
export let isDisablePreload = window.location.href.indexOf('disable_preload=1')>=0;
export let isOffline = window['IS_OFFLINE'];
export let isBigEventOptimization = (window.hasOwnProperty('EVENT_COUNTRY') && window['EVENT_COUNTRY'] === 'AE');
if (window.location.href.indexOf('isBigEventOptimization=1')>=0) {
  isBigEventOptimization = true;
}
isDisablePreload = true;
export let isDisableGenerationStatus = window.location.href.indexOf('generation_status_disabled=1')>=0;
if (window['EVENT_ID'] == 31329 || window['EVENT_ID'] == 34614) {
  isDisableBabyNumber = true;

}
export let isDisableDraw = window.location.href.indexOf('disable_draw=1')>=0;
export let superDuperMassiv = [];
export let isCanvasStoreAllowed = window['CANVAS_STORE_ALLOWED'];
export let eventVersions = window['VERSIONS'];
export let GOOGLE_SATELLITE_TILE_URL = window['GOOGLE_SATELLITE_TILE_URL'];
export let GOOGLE_TILE_SUBDOMAINS = window['GOOGLE_TILE_SUBDOMAINS'];
export let MAP_ROTATION_ALLOWED = window['MAP_ROTATION_ALLOWED'];
window['superDuperMassiv'] = superDuperMassiv;

export function reinitialize() {
  isViewMode = window['VIEW_ONLY'];
  isViewModeByShareLink = window.location.href.indexOf('/link-share/view') >= 0;
  isOffline = window['IS_OFFLINE'];
  if (window['EVENT_ID'] == 31329 || window['EVENT_ID'] == 34614) {
    isDisableBabyNumber = true;
  }
  isCanvasStoreAllowed = window['CANVAS_STORE_ALLOWED'];
  eventVersions = window['VERSIONS'];
  GOOGLE_SATELLITE_TILE_URL = window['GOOGLE_SATELLITE_TILE_URL'];
  GOOGLE_TILE_SUBDOMAINS = window['GOOGLE_TILE_SUBDOMAINS'];
}
